import styled from 'styled-components';

export const Header = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;
